import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'

const app = createApp(App)

document.documentElement.setAttribute('dir', 'rtl')
document.documentElement.setAttribute('lang', 'fa')

app.use(router)
app.mount('#app')
